import ReactOnRails from 'react-on-rails';

import Subscribe from '@components/pages/Subscribe/index';

ReactOnRails.register({
  Subscribe,
});
